import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BarChart3, Timer, Bot, MessageSquare, Phone, Mail } from "lucide-react";

const ICON = { chat: MessageSquare, phone: Phone, email: Mail };

export default function SupportAnalytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/support/analytics").then((r) => setA(r.data)).catch(() => {}); }, []);
  if (!a) return null;
  const max = Math.max(1, ...Object.values(a.by_channel).map((c) => c.total));
  return (
    <div className="p-4 rounded-xl bg-[#131722] border border-slate-800 space-y-4" data-testid="support-analytics">
      <p className="text-xs font-mono uppercase tracking-widest text-cyan-400 flex items-center gap-1.5"><BarChart3 className="w-3.5 h-3.5" />Last {a.window_days} days</p>
      <div className="grid grid-cols-3 gap-3">
        {[["Tickets", a.total, `${a.last7} this week`, "an-total"],
          ["Human response", a.avg_human_response_hours != null ? `${a.avg_human_response_hours}h` : "—", `${a.human_replies} replies`, "an-response"],
          ["AI resolved", a.ai_resolution_rate != null ? `${a.ai_resolution_rate}%` : "—", `${a.ai_auto_replied_emails} emails auto-replied`, "an-ai"]].map(([l, v, s, tid]) => (
          <div key={l} className="p-3 rounded-lg bg-slate-900/60 border border-slate-800" data-testid={tid}>
            <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1">{l === "Human response" ? <Timer className="w-3 h-3" /> : l === "AI resolved" ? <Bot className="w-3 h-3" /> : null}{l}</p>
            <p className="font-display font-extrabold text-xl mt-0.5">{v}</p>
            <p className="text-[11px] text-slate-500">{s}</p>
          </div>
        ))}
      </div>
      <div className="space-y-1.5" data-testid="an-channels">
        {Object.entries(a.by_channel).map(([ch, c]) => { const I = ICON[ch] || MessageSquare; return (
          <div key={ch} className="flex items-center gap-2 text-xs">
            <I className="w-3.5 h-3.5 text-slate-400" /><span className="w-12 capitalize text-slate-300">{ch}</span>
            <div className="flex-1 h-2 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-gradient-to-r from-blue-500 to-cyan-400 transition-all" style={{ width: `${(c.total / max) * 100}%` }} /></div>
            <span className="font-mono text-slate-400 w-20 text-right">{c.total} · {c.open} open</span>
          </div>
        ); })}
      </div>
      <div className="flex gap-3 text-[11px] text-slate-400"><span>😀 {a.sentiment.positive}</span><span>😐 {a.sentiment.neutral}</span><span>😠 {a.sentiment.negative}</span></div>
      {a.top_issues?.length > 0 && <div data-testid="an-top-issues">
        <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-1.5">Top customer issues</p>
        <ol className="space-y-1.5">{a.top_issues.map((t, i) => (
          <li key={i} className="text-xs flex gap-2"><span className="font-mono text-cyan-400">{t.count}×</span><span className="text-slate-200">{t.issue}</span>{t.tip && <span className="text-slate-500 hidden sm:inline">— {t.tip}</span>}</li>
        ))}</ol>
      </div>}
    </div>
  );
}
